module.exports = __webpack_public_path__ + "img/dash-board.669114f4.png";